export default "__VITE_ASSET__c9c873c3__"